<template>
  <div class="companies">
    <SectionHeader :title="$t('companies.locations')">
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('companies.locations'), name: 'company_locations' },
            {
              text: location.name,
              name: 'company_location',
              params: { location_uuid: $route.params.location_uuid },
            },
            { text: $t('companies.addDumpingStation') },
          ]"
        />
      </template>
    </SectionHeader>
    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <LoadingSpinner v-if="loading" full />
        <div v-else class="content-wrap">
          <Form :bodyClass="''" :title="$t('meta.baseData')" @submit="onFormSubmitted">
            <FormInput v-model="dumpingStation.name" :name="$t('meta.name')" type="text" required />
            <GeoCoder
              :latitude="dumpingStation.lat"
              :longitude="dumpingStation.lng"
              :mapCenter="{ lat: location.lat, lng: location.lng }"
              @coordinates="getCoordinates"
            />
            <Button type="submit" fullWidth>{{ $t('meta.save') }}</Button>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import Button from '@/components/Button/index.vue'
import FormInput from '@/components/Form/Input/index.vue'
import Form from '@/components/Form/index.vue'
import LoadingSpinner from '@/components/LoadingSpinner'
import SectionHeader from '@/components/SectionHeader/index.vue'
import CompanyNav from '@/components/company_nav'
import GeoCoder from '@/components/geocoder'

import locationsApi from '@/api/locations'

export default {
  name: 'company_location_dumping_station',
  data() {
    return {
      location: {},
      dumpingStation: {},
      loading: true,
    }
  },
  components: {
    BreadCrumbs,
    Button,
    CompanyNav,
    Form,
    FormInput,
    GeoCoder,
    LoadingSpinner,
    SectionHeader,
  },
  methods: {
    getCoordinates(value) {
      this.dumpingStation.lat = value[1]
      this.dumpingStation.lng = value[0]
    },
    async addDumpingStation() {
      const created = await locationsApi.createDumpingStation(this.$route.params.location_uuid, this.dumpingStation)
      if (created) {
        await this.$router.push(`/company/locations/${this.$route.params.location_uuid}`)
      }
    },
    async onFormSubmitted() {
      await this.addDumpingStation()
    },
  },
  async mounted() {
    this.location = await locationsApi.get(this.$route.params.location_uuid)
    this.loading = false
  },
}
</script>
